import React, { useState, useEffect } from "react";

import businessTermsApi from "apis/businessTerms";
import dataSourcesExploreApi from "apis/dataSourcesExplore";
import { Button, Pane, Typography, Table } from "clearsense-ui/components";

import { ASSOCIATE_BUSINESS_TERM_COLUMN } from "../../constants/associateBusinessTerm";

const AssociateBusinessTerms = ({
  isPaneOpen,
  setIsPaneOpen,
  dataSource,
  fetchBusinessTerms,
  getDataSource,
}) => {
  const [selected, setSelected] = useState([]);
  const [rowData, setRowData] = useState();

  const addToSelected = item => {
    const itemIndex = selected.findIndex(each => each === item);
    if (itemIndex === -1) setSelected([...selected, item]);
    else {
      const selectedCopy = [...selected];
      selectedCopy.splice(itemIndex, 1);
      setSelected(selectedCopy);
    }
  };

  const loadBusinessTermsList = async () => {
    try {
      const { data } = await businessTermsApi.fetch("", 1, 1000);
      setRowData(
        data.business_terms?.filter(
          business_term =>
            !business_term?.data_sources_data
              ?.map(data_source => data_source.id)
              .includes(dataSource?.id)
        )
      );
    } catch (error) {
      logger.log(error);
    }
  };

  const addCheckToSelected = () => {
    setRowData(
      rowData
        ?.map(row =>
          selected.includes(row.id)
            ? { ...row, checked: true }
            : { ...row, checked: false }
        )
        .sort((a, b) => b.checked - a.checked || a.name.localeCompare(b.name))
    );
  };

  const closePane = () => {
    setSelected([]);
    loadBusinessTermsList();
    setIsPaneOpen(false);
  };

  const handleClose = async () => {
    try {
      await dataSourcesExploreApi.associateBusinessTerms(dataSource?.id, {
        ids: selected,
      });
      fetchBusinessTerms();
      getDataSource();
      closePane();
    } catch (error) {
      logger.error(error);
    }
  };

  useEffect(() => loadBusinessTermsList(), []);
  useEffect(() => addCheckToSelected(), [selected]);

  return (
    <Pane isOpen={isPaneOpen} onClose={closePane}>
      <Pane.Header>
        <Typography style="h3" type="bold" className="-mt-3">
          Associate Business Terms to {dataSource?.name}
        </Typography>
        <Typography style="large">Description</Typography>
      </Pane.Header>
      <Pane.Body>
        <Table
          columnData={ASSOCIATE_BUSINESS_TERM_COLUMN}
          rowData={rowData}
          allowRowClick
          onRowClick={(e, record) => addToSelected(record.id)}
          rowKey={row => row.id}
          data-cy="associate-business-terms-table"
        />
      </Pane.Body>
      <Pane.Footer className="gap-4">
        <Button
          label="Save and Close"
          onClick={handleClose}
          disabled={selected.length === 0}
          data-cy="save-and-cancel"
        />
        <Button
          label="Cancel"
          style="secondary"
          onClick={closePane}
          data-cy="cancel"
        />
      </Pane.Footer>
    </Pane>
  );
};
export default AssociateBusinessTerms;
